<template>
  <v-card-text style="color: #4F4F4F">
    <v-row class="pa-3">
      Your user account for HawkSoft E-Signature has been activated. You are almost done.
    </v-row>
    <ol class="pb-3">
      <li style="text-align: start">Restart HawkSoft CMS and begin sending documents for electronic signature.</li>
      <li style="text-align: start"> If you forgot your previous E-Signature password, click the "Forgot password" link when logging into my.insuresign.com.</li>
    </ol>
  </v-card-text>
</template>

<script>

export default {
  name: 'Reactivate'
};

</script>
